import Button from "@mui/material/Button";
import * as React from "react";
import API from "@/api/serverCall";
import { applicationInfoType, applicationDetailInfoType } from "types/app";
import { useSnackbar } from "notistack";

type valueType = {
	packageAndroid: string;
	packageIos: string;
};
interface IEditPackageComponentProps {
	editPackageName: valueType;
	setEditPackageName: (value: valueType) => void;
	appObject: valueType;
	appObjectId: number;
	setOpenEditPackageComponent: (value: boolean) => void;
	appObjectName: string;
	setApplicationDetailInfo: (value: applicationDetailInfoType) => void;
	ApplicationDetailInfo: applicationDetailInfoType;
}

const EditPackageComponent: React.FC<IEditPackageComponentProps> = ({
	editPackageName,
	setEditPackageName,
	appObject,
	appObjectId,
	setOpenEditPackageComponent,
	appObjectName,
	setApplicationDetailInfo,
	ApplicationDetailInfo,
}) => {
	const { enqueueSnackbar } = useSnackbar();
	const EditPackageFunc = (appInfo: valueType) => {
		try {
			if (appInfo.packageAndroid !== "" && appInfo.packageIos !== "") {
				const requestData = {
					name: appObjectName,
					id: appObjectId,
					packageAndroid: appInfo.packageAndroid,
					packageIos: appInfo.packageIos,
				};

				API.PATCH<applicationInfoType>({
					link: `/app`,
					body: requestData,
				}).then((response) => {
					setApplicationDetailInfo({
						...ApplicationDetailInfo,
						app: response.data,
					});
					setOpenEditPackageComponent(false);
					enqueueSnackbar("패키지명이 입력되었습니다", {
						variant: "info",
					});
				});
			}
		} catch (error) {
			console.error(error);
		}
	};
	return (
		<div
			style={{
				display: "flex",
				justifyContent: "flex-end",
				paddingRight: "1.5rem",
				marginBottom: "1rem",
			}}
		>
			<Button
				variant="outlined"
				sx={{
					color: "#747474",
					borderColor: "#CCCCCC",
					marginRight: "0.5rem",
				}}
				onClick={() => {
					setEditPackageName(appObject);
					setOpenEditPackageComponent(false);
				}}
			>
				취소
			</Button>
			<Button
				variant="contained"
				sx={{ backgroundColor: "#2453F9", color: "white" }}
				onClick={() => {
					EditPackageFunc(editPackageName);
				}}
			>
				변경
			</Button>
		</div>
	);
};
export default EditPackageComponent;
